import {HttpRequest,HttpMethod} from "./http";

class ReportProvider extends HttpRequest {


	ReportSaleChannel(params){
		return this.request(HttpMethod.Get,`/api/v2/reports/recbysalechannel`,params );
	}

	ReportProduct(params){
		return this.request(HttpMethod.Get,`/api/v1/reports/recbyproduct`,params );
	}

	ReportUser(params){
		return this.request(HttpMethod.Get,`/api/v2/reports/recbyuser`,params );
	}

	ReportUserTeam(params){
		return this.request(HttpMethod.Get,`/api/v1/reports/recbyteam`,params );
	}

	ReportUserAndProduct(params){
		return this.request(HttpMethod.Get,`/api/v2/reports/recbyuserproduct`,params );
	}

	ReportDashboard(params){
		return this.request(HttpMethod.Get,`/api/v1/reports/dashboard`,params );
	}
	
	ReportSummaryWmsProduct(params){
		return this.request(HttpMethod.Get,`/api/v2/reports/summary_wms_product`,params );
	}

	ReportSummaryWmsProductAsync(params){
		return this.request(HttpMethod.Get,`/api/v2/reports/summary_wms_product_async`,params );
	}
	

	ReportCommission(params){
		return this.request(HttpMethod.Get,`/api/v1/reports/commission`,params );
	}

	ReportSaleChannelProduct(params){
		return this.request(HttpMethod.Get,`/api/v1/reports/salebyplatformandpromotion`,params );
	}

	ReportOrderReturn(params){
		return this.request(HttpMethod.Get,`/api/v1/reports/orderreturn`,params );
	}

	ReportDashboardByPlatformChannel(params){
		return this.request(HttpMethod.Get,`/api/v2/reports/dashboard_by_platform_channel`,params );
	}

	// ---- รายงานต้นทุน (#265 · bo-api #594 §6.1) ----------------------------
	// All five sit behind mw.IsProductCost on the API: a caller whose email is
	// not in config.yml's product_cost.emails gets 403 product_cost_forbidden,
	// which http.js turns into a permission dialog (NOT a logout).
	ReportCostRoot(params){
		return this.request(HttpMethod.Get,`/api/v1/reports/cost`,params );
	}

	ReportCostPromotions(params){
		return this.request(HttpMethod.Get,`/api/v1/reports/cost/promotions`,params );
	}

	ReportCostSkus(params){
		return this.request(HttpMethod.Get,`/api/v1/reports/cost/skus`,params );
	}

	ReportCostOrders(params){
		return this.request(HttpMethod.Get,`/api/v1/reports/cost/orders`,params );
	}

	ProductCostRecompute(params){
		return this.request(HttpMethod.Post,`/api/v1/product-cost/recompute`,params );
	}

	// Re-snapshot bo_orders_item.unit_cost for one date range (#267 · bo-api
	// #599 §13.5). NOT the same button as ProductCostRecompute above: that one
	// re-prices the SKU catalogue and deliberately never touches a past order
	// line, and this one is the only door through which a past order line's cost
	// ever changes. Same allowlist, and it always carries time_from/time_to.
	//
	// THE DATES GO IN THE QUERY STRING, AND THE BODY IS EMPTY (#268).
	//
	// The handler parses its range with go-core's Validator.DateStartEnd
	// (go-core@v1.8.2/Validator.go:639), which chooses its source by METHOD:
	//
	//     paramStartDate := c.QueryParam(fieldStartName)
	//     if method == echo.POST || method == echo.PUT || method == echo.DELETE {
	//         paramStartDate = c.FormValue(fieldStartName)
	//
	// This is a POST, so it takes the c.FormValue branch — net/http's
	// Request.FormValue, which reads r.Form. ParseForm always merges the URL
	// query into r.Form, but only reads the BODY when the request is
	// application/x-www-form-urlencoded or multipart. http.js sends every POST
	// as application/json (see its defaults.headers.post block), so passing
	// {time_from,time_to} as the payload makes them literally unreadable to the
	// handler: both come back "", DateStartEnd runs with required = true, and
	// the answer is 400 cost_report_bad_range on every press
	// (controllers/OrderItemCostBackfillHandler.go:54).
	//
	// Hence the manual query string. It is NOT built into backfillParams():
	// that util stays a plain {time_from, time_to} object with no opinion about
	// transport, and this — the one place that talks to this one endpoint — is
	// where the quirk belongs. encodeURIComponent is on principle rather than
	// need (the picker only ever emits YYYY-MM-DD), because an unescaped value
	// is how a stray & would split one parameter into two.
	ProductCostBackfillOrders(params){
		const p = params || {};
		const query = [
			`time_from=${encodeURIComponent(p.time_from || "")}`,
			`time_to=${encodeURIComponent(p.time_to || "")}`,
		].join("&");
		return this.request(HttpMethod.Post,`/api/v1/product-cost/backfill-orders?${query}`,null );
	}
}

export default ReportProvider